<div class="auth-container">
    <router-outlet></router-outlet>
    <div class="auth-footer">
        <small class="text-muted">© {{_util.currentYear}} <a href="#"><small class="text-muted">Walkzero</small></a> - All rights reserved
        </small>
    </div>
</div>